/**
 * Moment-adapter
 */

define('moment-adapter', ['moment', 'moment/calculatedLocale'], function (moment) {
    moment.locale('de');

    // Set the global.
    window.moment = moment;

    return moment;
});
